import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "services", label: "Services" },
  { id: "transformations", label: "Transformations" },
  { id: "service-area", label: "Service Area" },
  { id: "book", label: "Book" },
  { id: "contact", label: "Contact" },
];

export default function Navbar({ onCta }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-black/10 text-black"
          : "bg-transparent text-white"
      }`}
    >
      <div className="pc-container flex h-16 items-center justify-between md:h-20">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="flex items-center gap-2 font-display text-2xl font-extrabold tracking-tight"
        >
          <span>
            Pristyn<span className="text-[var(--pc-green-hover)]">.</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-link-${n.id}`}
              onClick={() => goTo(n.id)}
              className={`text-sm font-medium transition-colors ${
                scrolled ? "text-black/70 hover:text-black" : "text-white/85 hover:text-white"
              }`}
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <button
            data-testid="nav-book-button"
            onClick={() => (onCta ? onCta() : goTo("book"))}
            className="pc-btn-primary !py-2.5 !px-5 text-sm"
          >
            Book Free Estimate
          </button>
        </div>

        <button
          data-testid="navbar-menu-toggle"
          className="md:hidden"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="navbar-mobile-menu" className="md:hidden bg-white border-t border-black/10">
          <div className="pc-container flex flex-col gap-1 py-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`nav-mobile-link-${n.id}`}
                onClick={() => goTo(n.id)}
                className="rounded-md px-2 py-3 text-left text-base font-medium hover:bg-black/5"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-book-button"
              onClick={() => {
                setOpen(false);
                if (onCta) onCta();
                else goTo("book");
              }}
              className="pc-btn-primary mt-2 justify-center"
            >
              Book Free Estimate
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
